let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("38sfA"), load("h4OCL"), load("awkVi"), load("1510B")]).then(() => parcelRequire('eMsCn'));